<template>
  <div class="section section--sharing">
    <h2 class="section__title">Sharing</h2>
    <div class="section__container">
      <div class="section__content" v-if="isLoggedIn">
        <div class="details">
          <transition name="slide" mode="out-in">
            <Listing
              v-if="status && status.latest && status.latest.listing"
              :latest="status.latest"
              :key="status.latest.listing.id"
            />
            <div class="status__listing status__listing--placeholder" v-else>
              <div class="image-placeholder"></div>
              <h2></h2>
              <p></p>
            </div>
          </transition>
          <div v-if="itemsCompleted && itemsTotal" class="status__progress">Listing {{itemsCompleted}} of {{itemsTotal}}</div>
        </div>
        <div class="info">
          <h3 class="info__title">About Sharing</h3>
          <p>We smartly share your closet throughout the day with our advanced systems that mimic a human, and stay within Poshmark’s internal thresholds for shares per day.</p>

          <p>We also automatically detect and solve CAPTCHAs for you for a truly automated experience.</p>
        </div>
        <div class="controls" v-if="isLoggedIn">
          <a class="control control--pause" href="javascript:void(0)" @click="togglePaused" v-if="!isPaused">Pause Sharing</a>
          <a class="control control--resume" href="javascript:void(0)" @click="togglePaused" v-if="isPaused">Resume Sharing</a>
          <a class="control control--restart" href="javascript:void(0)" @click="restart">Restart Sharing</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Listing from './Listing.vue';

export default {
  components: { Listing },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isPaused() {
      return this.$store.state.isPaused;
    },
    status() {
      return this.$store.state.status;
    },
    itemsTotal() {
      if (!this.status.completed) {
        return null;
      }
      return this.status.waiting
        + this.status.active
        + this.status.completed
        + this.status.failed
        + this.status.delayed
        + this.status.paused;
    },
    itemsCompleted() {
      return this.status.completed;
    },
  },
  methods: {
    togglePaused() {
      this.$store.dispatch('togglePaused');
    },
    restart() {
      this.$store.dispatch('restart');
    },
  },
  beforeCreate() {
    if (this.$store.state.loginToken) {
      this.$store.dispatch('startUpdater');
    }
  },
};
</script>
